import S from './Admin.module.scss';
import {Link} from "react-router-dom";
import {useState} from "react";
import UserManagement from "./UserManagement";
import CompanyRegister from "./CompanyEditor";
import CompanyManagement from "./CompanyManagement";
import RecruitmentManagement from "./RecruitmentManagement";

interface AdminProps {
    masterToken: string;
}

const Admin = (props: AdminProps) => {
    const { masterToken } = props;
    const ADMIN_TOKEN = process.env.REACT_APP_IVY_ADMIN_TOKEN || '';
    const [activeMenu, setActiveMenu] = useState<string>('user-management');

    const renderComponent = () => {
        switch (activeMenu) {
            case 'user-management':
                return <UserManagement masterToken={masterToken}/>;
            case 'company-management':
                return <CompanyManagement />;
            case 'recruitment-management':
                return <RecruitmentManagement />;
            default:
                return <UserManagement masterToken={masterToken} />;
        }
    };

    if (masterToken !== ADMIN_TOKEN) {
        return null;
    }
    return (
      <div className={S.wrapper}>
        <div className={S.sidebar}>
          <h1 className={S.title}>IVY LEAGUER</h1>
          <nav className={S.navMenu}>
            <ul>
              <li onClick={() => setActiveMenu('user-management')}>사용자 관리</li>
              <li onClick={() => setActiveMenu('company-management')}>기업 관리</li>
              <li onClick={() => setActiveMenu('recruitment-management')}>채용 공고 관리</li>
            </ul>
          </nav>
        </div>
        <div className={S.content}>{renderComponent()}</div>
      </div>
    );
}



export default Admin;